<template>
  <div class="page">
    <Breadcrumb title="平台设置" :breadcrumb="breadcrumb" />
    <div class="content">
      <div class="new-create">新建应用</div>
      <!-- 创建应用 -->
      <blue-title>新建应用</blue-title>
      <!-- 创建表单 -->
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-position="left"
        label-width="120px"
        class="ruleForm"
      >
        <el-form-item label="应用code" prop="applyCode">
          <el-input v-model="ruleForm.applyCode" placeholder="请输入应用code"></el-input>
        </el-form-item>
        <el-form-item label="应用名称" prop="applyName">
          <el-input v-model="ruleForm.applyName" placeholder="请输入应用名称"></el-input>
        </el-form-item>
        <el-form-item label="支付店铺名" prop="payName">
          <el-input v-model="ruleForm.payName" placeholder="请输入支付店铺名"></el-input>
        </el-form-item>
        <el-form-item label="应用简介" prop="profile">
          <el-input
            type="textarea"
            :autosize="{ minRows: 3 }"
            v-model="ruleForm.profile"
            placeholder="请输入应用简介"
          ></el-input>
        </el-form-item>
        <el-form-item label="应用支付方式" prop="applyType">
          <div>
            <el-radio v-model="ruleForm.applyType" label="ZWBY">
              <span class="paytype-main">支付聚合平台</span>
              <span class="paytype-sub">（使用支付聚合平台的微信、支付宝、银联等）</span>
            </el-radio>
          </div>
          <div>
            <el-radio v-model="ruleForm.applyType" label="HEEMONEY">
              <span class="paytype-main">汇付宝</span>
              <span class="paytype-sub">（使用汇付宝的微信、支付宝、银联等）</span>
            </el-radio>
          </div>
        </el-form-item>

        <blue-title class="ip">访问ip</blue-title>
        <el-form-item label="ip白名单" prop="ipList">
          <div class="box_row">
            <el-input
              type="textarea"
              :autosize="{ minRows: 5 }"
              v-model="ruleForm.ipList"
              placeholder="需要使用出款类API接口，请先配置接口访问IP（多条ip地址请用“,”分隔开）"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item class="form-footer">
          <el-button type="primary" @click="submitForm('ruleForm')">保存配置</el-button>
          <el-button @click="resetForm()">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { breadcrumb } from '@/mixins/index.js';
export default {
  computed: {
    ...mapGetters('applyCreat', ['applyKey']),
  },
  mixins: [breadcrumb],
  data() {
    return {
      // 应用表单
      ruleForm: {
        payName: '',
        applyType: 'ZWBY',
        applyName: '',
        applyCode: '',
        applyKey: '',
        ipList: '',
        profile: '',
        companyId: '',
      },
      // 表单验证
      rules: {
        payName: [{ required: true, message: '您未输入支付店铺名/支付店铺名重复', trigger: 'blur' }],
        applyName: [{ required: true, message: '您未输入应用名称/应用名称重复', trigger: 'blur' }],
        applyCode: [{ required: true, message: '您未输入应用Code/请输入正确的应用Code/应用Code重复', trigger: 'blur' }],
        ipList: [{ required: true, message: '请至少输入“/**”', trigger: 'blur' }],
        profile: [{ required: true, message: '您未输入应用简介', trigger: 'blur' }],
        applyType: [{ required: true, message: '您未选择应用支付方式', trigger: 'blur' }],
      },
      // 修改表单id
      id: '',
    };
  },
  methods: {
    ...mapActions('applyCreate', ['newApply','queryAllApply']),
    ...mapActions('applyUpdate', ['getApplyDetail','updateApplyDetail']),
    // 保存配置
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          console.log('新建应用信息：', this.ruleForm, this.$store);
          if (this.id != '') {
            this.updateApplyDetail(this.ruleForm);
          } else {
            this.newApply(this.ruleForm);
          }
          this.$message.success('保存成功');
          this.$router.push({ name: 'apply/index' });
        }
      });
    },
    // 取消
    resetForm() {
      this.$router.go(-1);
    },
    // 获取详情
    async getDetail() {
      var result = await this.getApplyDetail({ id: this.id });
      this.ruleForm = result;
    },
  },
  mounted() {
    this.ruleForm.companyId = JSON.parse(localStorage.getItem('loginUesr')).companyInfo.id;
    if (this.$route.name == 'apply/update') {
      this.id = this.$route.query.id;
      this.getDetail();
    }
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.page {
  width: 100%;
}
.content {
  margin-top: 15px;
  padding: 30px 30px 30px 15px;
  background: #fff;
}
.new-create {
  font-size: 20px;
  font-weight: 500px;
  margin-bottom: 30px;
  padding-left: 15px;
}
.ruleForm {
  margin: 30px;
  .el-input {
    width: 70%;
  }
  .el-textarea {
    width: 70%;
  }
  .form-footer {
    .el-button {
      padding: 9px 16px;
      font-size: 16px;
    }
    margin: 70px 0 0 -100px;
  }
}
.ip {
  margin: 60px 0 20px -10px;
}
.add {
  width: 40px;
  height: 40px;
  width: 121px;
  color: #4359b7;
  border-color: #4359b7;
  font-size: 14px;
  padding: 10px 16px;
  margin-right: 40px;
}
.paytype-main {
  color: #333;
  font-weight: normal;
  font-size: 14px;
}
.paytype-sub {
  color: #999;
  font-weight: normal;
  font-size: 14px;
}
</style>
